<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Crear Colegio",
            items: [
                { text: "Configuración", href: "/" },
                { text: "Crear Colegio", active: true }
            ],
            isLoading: false,
            colegios_opciones: [],
            estados: [],
            opciones: ['Si','No'],
            colegio: {
                rbd: '',
                nombre: '',
                direccion: '',
                comuna: '',
                provincia: '',
                region: '',
                telefono_colegio: '',
                telefono_director: '',
                telefono_orientador: '',
                nombre_director: '',
                correo_colegio: '',
                nombre_orientador: '',
                correo_colegio_2: '',
                colegio_visitado: '',
                estado_id: '',
                sede_asociada: '',
                propietario: ''
            },
            phoneerror1: '',
            phoneerror2: '',
            phoneerror3: '',
            emailError1: '',
            emailError2: '',
            submitIntent: false
        };
    },
    computed: {
        isEmailValid1() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegio.correo_colegio);
        },
        isEmailValid2() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegio.correo_colegio_2);
        }
    },
    methods: {
        msg(tipo, titulo) {
            Swal.fire({ icon: tipo, title: titulo, showConfirmButton: false, timer: 3000 });
        },
        validateEmail1() {
            if (this.colegio.correo_colegio && !this.isEmailValid1) {
                this.emailError1 = 'El correo electrónico no es válido.';
            } else {
                this.emailError1 = '';
            }
        },
        validateEmail2() {
            if (this.colegio.correo_colegio_2 && !this.isEmailValid2) {
                this.emailError2 = 'El correo electrónico no es válido.';
            } else {
                this.emailError2 = '';
            }
        },
        formatPhoneNumber1() {
            if (!this.colegio.telefono_director) return;
            let digits = this.colegio.telefono_director.replace(/\D/g, "");
            if (!digits.startsWith("56")) digits = "56" + digits;
            if (digits.length > 11) digits = digits.slice(0, 11);
            this.colegio.telefono_director = "+" + digits;
        },
        validatePhoneNumber1() {
            if (!this.colegio.telefono_director) return;
            if (this.colegio.telefono_director.length !== 12) {
                this.phoneerror1 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror1 = "";
            }
        },
        formatPhoneNumber2() {
            if (!this.colegio.telefono_colegio) return;
            let digits = this.colegio.telefono_colegio.replace(/\D/g, "");
            if (!digits.startsWith("56")) digits = "56" + digits;
            if (digits.length > 11) digits = digits.slice(0, 11);
            this.colegio.telefono_colegio = "+" + digits;
        },
        validatePhoneNumber2() {
            if (!this.colegio.telefono_colegio) return;
            if (this.colegio.telefono_colegio.length !== 12) {
                this.phoneerror2 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror2 = "";
            }
        },
        formatPhoneNumber3() {
            if (!this.colegio.telefono_orientador) return;
            let digits = this.colegio.telefono_orientador.replace(/\D/g, "");
            if (!digits.startsWith("56")) digits = "56" + digits;
            if (digits.length > 11) digits = digits.slice(0, 11);
            this.colegio.telefono_orientador = "+" + digits;
        },
        validatePhoneNumber3() {
            if (!this.colegio.telefono_orientador) return;
            if (this.colegio.telefono_orientador.length !== 12) {
                this.phoneerror3 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror3 = "";
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = ["Backspace","Tab","ArrowLeft","ArrowRight","Delete"];
            if (!allowedKeys.includes(event.key) && !/^\d$/.test(event.key)) event.preventDefault();
        },
        restrictInput(event) {
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) event.preventDefault();
        },
        restrictInput_withspace(event) {
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);
            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) event.preventDefault();
        },
        validacion() {
            this.submitIntent = true;
            const campos = {
                nombre: 'Nombre Colegio',
                nombre_director: 'Nombre Director',
                correo_colegio: 'Correo Director',
                telefono_director: 'Teléfono Director',
                telefono_colegio: 'Teléfono',
                nombre_orientador: 'Nombre Orientador',
                correo_colegio_2: 'Correo Orientador',
                telefono_orientador: 'Teléfono Orientador',
                colegio_visitado: '¿Colegio Visitado?',
                estado_id: 'Estado',
            };
            for (let campo in campos) {
                if (!this.colegio[campo]) {
                    this.msg('error', `Falta: ${campos[campo]}`);
                    return false;
                }
            }
            if (this.emailError1 || this.emailError2 || this.phoneerror1 || this.phoneerror2 || this.phoneerror3) {
                this.msg('error', 'Corregir errores en el formulario');
                return false;
            }
            return true;
        },
        createColegio() {
            if (!this.validacion()) return;
            this.isLoading = true;
            axios.post('/api/crear_colegio', this.colegio).then(res => {
                if (res.data && res.data.estado) {
                    this.msg('success', res.data.mensaje || 'Colegio creado');
                    this.colegio = {
                        rbd: '', nombre: '', direccion: '', comuna: '', provincia: '', region: '',
                        telefono_colegio: '', telefono_director: '', telefono_orientador: '',
                        nombre_director: '', correo_colegio: '', nombre_orientador: '', correo_colegio_2: '',
                        colegio_visitado: '', estado_id: '', sede_asociada: '', propietario: ''
                    };
                    this.submitIntent = false;
                } else {
                    this.msg('error', (res.data && res.data.mensaje) || 'Error al crear colegio');
                }
            }).catch(err => {
                console.error(err);
                this.msg('error', 'Error en la solicitud');
            }).finally(() => this.isLoading = false);
        }
    },
    mounted() {
        axios.get(`/api/get_estado_colegios`).then(response => {
            this.estados = response.data.estados || [];
        }).catch(()=>{});
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6"><label>RBD:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-primary"> Opcional / se asigna automático</label></div>
                                    <div class="col-md-12"><input v-model="colegio.rbd" class="form-control border-primary" @keypress="restrictToNumbers"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Nombre Colegio:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.nombre" :class="['form-control border-primary', { 'is-invalid': submitIntent && !colegio.nombre }]"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Dirección:</label></div>
                                    <div class="col-md-6 text-right"></div>
                                    <div class="col-md-12"><input v-model="colegio.direccion" class="form-control border-primary"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Comuna:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-primary"></label></div>
                                    <div class="col-md-12"><input v-model="colegio.comuna" class="form-control border-primary"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Provincia:</label></div>
                                    <div class="col-md-6 text-right"></div>
                                    <div class="col-md-12"><input v-model="colegio.provincia" class="form-control border-primary"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Región:</label></div>
                                    <div class="col-md-6 text-right"></div>
                                    <div class="col-md-12"><input v-model="colegio.region" class="form-control border-primary"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Nombre Director:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.nombre_director" class="form-control border-primary" @keypress="restrictInput_withspace"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Correo Director:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.correo_colegio" class="form-control border-primary" @blur="validateEmail1"><p v-if="emailError1" class="error text-primary">{{ emailError1 }}</p></div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Teléfono Colegio:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.telefono_colegio" class="form-control border-primary" @input="formatPhoneNumber2" @blur="validatePhoneNumber2"><p v-if="phoneerror2" class="error text-primary">{{ phoneerror2 }}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Nombre Orientador:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.nombre_orientador" class="form-control border-primary" @keypress="restrictInput_withspace"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Correo Orientador:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.correo_colegio_2" class="form-control border-primary" @blur="validateEmail2"><p v-if="emailError2" class="error text-primary">{{ emailError2 }}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Teléfono Orientador:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.telefono_orientador" class="form-control border-primary" @input="formatPhoneNumber3" @blur="validatePhoneNumber3"><p v-if="phoneerror3" class="error text-primary">{{ phoneerror3 }}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>¿Colegio visitado?:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12">
                                        <select v-model="colegio.colegio_visitado" class="form-control border-primary">
                                            <option value="">Seleccionar</option>
                                            <option v-for="op in opciones" :key="op" :value="op">{{ op }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Estado:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12">
                                        <select v-model="colegio.estado_id" class="form-control border-primary">
                                            <option value="">Seleccionar</option>
                                            <option v-for="est in estados" :key="est.codigo" :value="est.codigo">{{ est.nombre }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label>Sede asociada</label>
                                        <input v-model="colegio.sede_asociada" class="form-control border-primary" />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label>Propietario</label>
                                        <input v-model="colegio.propietario" class="form-control border-primary" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label>Teléfono Director:</label></div>
                                    <div class="col-md-6 text-right"><label class="text-danger"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input v-model="colegio.telefono_director" class="form-control border-primary" @input="formatPhoneNumber1" @blur="validatePhoneNumber1"><p v-if="phoneerror1" class="error text-primary">{{ phoneerror1 }}</p></div>
                                </div>
                            </div>
                            <div class="offset-lg-3 col-lg-6 mt-3">
                                <b-button block variant="primary" @click="createColegio">Crear Colegio</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
